import api from '../../api'

export const SET_CHIPTYPE_LIST = 'SET_CHIPTYPE_LIST'
const SET_NGS_SOURCES_LIST = 'SET_NGS_SOURCES_LIST'
const SET_SAMPLE_TYPES = 'SET_SAMPLE_TYPES'
const ADD_SAMPLE_TYPE = 'ADD_SAMPLE_TYPE'
const SET_PERSONALS = 'SET_PERSONALS'

const initialState = {
	chipTypes: {},
	chipTypes_list: [],
	ngs_sources_list: [],
	sample_types_list: [],
	personals: []
}

const actions = {

	add_sample_type: function ({commit}, {sample_type}) {
		commit(ADD_SAMPLE_TYPE, sample_type)
	},


	listSampleTypes: function ({commit}) {
		return api.others.listSampleTypes()
			.then(function (response) {
				commit(SET_SAMPLE_TYPES, response.data)
			})
	},
	listChipTypes: function ({commit}) {
		console.log('store.others.listChipTypes')

		return api.others.listChipTypes()
			.then(function (response) {
				// полученные из REST данные разложить в state через мутации
				// Данные из PgmToolsRest приходят в виде ...,

				const data = response.data

				commit(SET_CHIPTYPE_LIST, data)
			})
	},

	defaultView: function ({dispatch}) {

		return dispatch('runs/getPlanningRunNames', null, {root: true})
			.catch(function (error) {
				dispatch('error/error_occurred', {error: error, ok: false}, {root: true})
			})


	},

	listNgsSources: function ({commit}) {
		console.log('store.others.listNgsSources')

		return api.others.listNgsSources()
			.then(function (response) {
				// полученные из REST данные разложить в state через мутации
				// Данные из PgmToolsRest приходят в виде ...,

				const data = response.data

				commit(SET_NGS_SOURCES_LIST, data)
			})
	},
	personals: function ({commit}) {
		return api.others.personals_hand_to()
			.then(function (response) {
				// полученные из REST данные разложить в state через мутации
				// Данные из PgmToolsRest приходят в виде ...,

				const data = response.data

				commit(SET_PERSONALS, data)
			})
	}

}

const mutations = {
	[SET_PERSONALS](state, personals) {
		state.personals = personals
	},

	[ADD_SAMPLE_TYPE](state, sample_type) {
		state.sample_types_list.push(sample_type)
	},

	[SET_SAMPLE_TYPES](state, s_t_list) {
		state.sample_types_list = s_t_list
	},


	[SET_CHIPTYPE_LIST](state, chipType_data) {
		console.log('store.others.mutations.SET_CHIPTYPE_LIST() ')

		// в store лучше организовать данные в виде словаря по ключу
		// и объектов со ссылкой на ключ и списков ключей

		for (let i = 0; i < chipType_data.length; i++) {
			const chipType = chipType_data[i]

			state.chipTypes[chipType.name] = chipType
		}
		state.chipTypes_list = chipType_data
	},
	[SET_NGS_SOURCES_LIST](state, ngs_sources_list) {
		state.ngs_sources_list = ngs_sources_list

	}
}

const getters = {
	chipTypes_list: function (state) {
		return state.chipTypes_list
	}
}

export default {
	namespaced: true,
	state: initialState,
	actions,
	mutations,
	getters
}